import React from 'react'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { FormControl, InputLabel, MenuItem, Select, TextField, CircularProgress } from '@mui/material';
import { oneriler, location } from '../../helper/data';
import useFeedbackCall from '../../hooks/useFeedbackCall';
import { validateContactFields } from '../../helper/contactValidation';

// Zorunlu iletişim alanları öneri ve talep kayıtlarında ortak kurallarla doğrulanır.
const CONTACT_RULES = {
  name: { type: "name", label: "İsim", required: true },
  surname: { type: "name", label: "Soyisim", required: true },
  phone: { type: "phone", label: "Telefon", required: true },
  email: { type: "email", label: "E-posta", required: true },
}

const OneriTalep_View = ({ loading }) => {

  const { postFireData } = useFeedbackCall()

  const now = new Date()

  // Gün, Ay ve Yıl için değerleri al
  const day = String(now.getDate()).padStart(2, '0'); // Günü 2 basamaklı yap
  const month = String(now.getMonth() + 1).padStart(2, '0'); // Ayı 2 basamaklı yap (0'dan başladığı için +1 ekliyoruz)
  const year = now.getFullYear();

  // Saat, Dakika ve Saniye için değerleri al
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');

  // Düzenlenmiş tarih ve saati birleştir
  const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}`;



  const [info, setInfo] = useState({
    name: "",
    surname: "",
    phone: "",
    email: "",
    topic: "Talep",
    katkiKonusu: "",
    oneriler: "",
    detail: "",
    actionType: "",
    actionResult: "",
    location: "",
    datetime: formattedDate

  })
  const [errors, setErrors] = useState({})

  const handleChange = (e) => {
    const { name, value } = e.target
    setInfo(prevInfo => ({ ...prevInfo, [name]: value }))
    setErrors(prevErrors => ({ ...prevErrors, [name]: undefined }))
  }

  const handleContactBlur = (e) => {
    const { name } = e.target
    if (!CONTACT_RULES[name]) return

    const validation = validateContactFields(info, { [name]: CONTACT_RULES[name] })
    setErrors(prevErrors => ({ ...prevErrors, [name]: validation.errors[name] }))
  }

  const handleSubmit = (e) => {

    e.preventDefault()

    const validation = validateContactFields(info, CONTACT_RULES)
    if (!validation.isValid) {
      setErrors(validation.errors)
      e.currentTarget.elements.namedItem(Object.keys(validation.errors)[0])?.focus()
      return
    }

    setErrors({})
    postFireData('oneri-talep', validation.values)

    setInfo({
      name: "",
      surname: "",
      phone: "",
      email: "",
      topic: "Talep",
      katkiKonusu: "",
      oneriler: "",
      detail: "",
      actionType: "",
      actionResult: "",
      location: "",
      datetime: formattedDate
    })

  }


  return (
    <div>

      <Typography align='center' color='#FFB534' p={3} fontWeight={700} fontSize={22}>Talep</Typography>

      <Typography variant='subtitle2' align='center' color={'error'}>
        Geri bildirimlerinizin takibi ve durumunu öğrenmek için telefon numarası ve mail adresinizin doğruluğu önemlidir !
      </Typography>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 5, p: 2 }}>

        <form onSubmit={handleSubmit}>

          <Box sx={{ flexDirection: 'column', display: 'flex', gap: 3, p: 3 }}>

            <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 3 }}>
              <TextField
                fullWidth
                required
                label='İsim'
                name='name'
                id='name'
                type='text'
                value={info.name}
                // inputProps={{
                //   maxLength: 50
                // }}
                onChange={handleChange}
                onBlur={handleContactBlur}
                error={!!errors.name}
                helperText={errors.name}
              />
              <TextField
                fullWidth
                required
                label='Soyisim'
                name='surname'
                id='surname'
                type='text'
                value={info.surname}
                // inputProps={{
                //   maxLength: 50
                // }}
                onChange={handleChange}
                onBlur={handleContactBlur}
                error={!!errors.surname}
                helperText={errors.surname}
              />
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 3 }}>
              <TextField
                required
                fullWidth
                label='Telefon (0xxx-xxx-xxxx)'
                name='phone'
                id='phone'
                type='tel'
                // inputProps={{
                //   maxLength: 11
                // }}
                value={info.phone}
                onChange={handleChange}
                onBlur={handleContactBlur}
                error={!!errors.phone}
                helperText={errors.phone}
              />
              <TextField
                fullWidth
                required
                label='E-posta'
                name='email'
                id='email'
                type='email'
                value={info.email}
                onChange={handleChange}
                onBlur={handleContactBlur}
                error={!!errors.email}
                helperText={errors.email}
              />
            </Box>

            {/* <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 3 }}>

              <FormControl fullWidth>
                <InputLabel id="topic">Talep Konusu</InputLabel>
                <Select
                  required
                  labelId="topic"
                  id="topic"
                  name='topic'
                  label="Talep Konusu"
                  value={info.topic}
                  onChange={handleChange}
                >
                  {
                    oneriKonusu.map((item, index) => (
                      <MenuItem key={index} value={item.name}>{item.name}</MenuItem>
                    ))
                  }

                </Select>
              </FormControl>

              <FormControl fullWidth>
                <InputLabel id="katkiKonusu">Öneri Fayda Konusu</InputLabel>
                <Select
                  required
                  labelId="katkiKonusu"
                  id="katkiKonusu"
                  name='katkiKonusu'
                  label="Öneri Fayda Konusu"
                  value={info.katkiKonusu}
                  onChange={handleChange}
                >
                  {
                    katkiKonusu.map((item, index) => (
                      <MenuItem key={index} value={item.name}>{item.name}</MenuItem>
                    ))
                  }

                </Select>
              </FormControl>

            </Box> */}

            <Box>
              <FormControl fullWidth>
                <InputLabel id="location">Lokasyon</InputLabel>
                <Select
                  required
                  labelId='location'
                  name='location'
                  id='location'
                  label='location'
                  value={info.location}
                  onChange={handleChange}
                >
                  {
                    location.map((item, index) => (
                      <MenuItem key={index} value={item}>{item}</MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Box>


            <Box>
              <FormControl fullWidth>
                <InputLabel id="oneriler">Öneri Konusu</InputLabel>
                <Select
                  required
                  labelId='oneriler'
                  name='oneriler'
                  id='oneriler'
                  label='oneriler'
                  value={info.oneriler}
                  onChange={handleChange}
                >
                  {
                    oneriler.map((item, index) => (
                      <MenuItem key={index} value={item}>{item}</MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Box>


            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <TextField
                fullWidth
                required
                multiline
                rows={4}
                label='Açıklama'
                name='detail'
                id='detail'
                type='text'
                value={info.detail}
                // inputProps={{
                //   maxLength: 250
                // }}
                onChange={handleChange}
              />
            </Box>


            {
              loading ?
                <CircularProgress size={20} color="inherit" />
                :

                <Button disabled={loading} variant='contained' type='submit'>
                  Kayıt
                </Button>
            }

          </Box>

        </form>

      </Box>

    </div>
  )
}

export default OneriTalep_View